import { Injectable } from '@angular/core';
import { HttpEvent, HttpResponse } from '@angular/common/http';
import {
  asyncScheduler,
  BehaviorSubject,
  distinctUntilChanged,
  Observable,
  observeOn,
  shareReplay,
} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HttpRequestTracker {
  readonly isReady$: Observable<boolean>;
  private readonly _isReady$: BehaviorSubject<boolean>;
  private readonly openRequests: Map<string, Observable<HttpEvent<unknown>>> =
    new Map();

  constructor() {
    this._isReady$ = new BehaviorSubject(false);
    this.isReady$ = this._isReady$.pipe(
      shareReplay(1),
      distinctUntilChanged(),
      observeOn(asyncScheduler)
    );
  }

  add(url: string, request: Observable<HttpEvent<unknown>>): void {
    this.openRequests.set(url, request);

    request.subscribe(this.handleResponse.bind(this, url));
  }

  remove(url: string): void {
    this.openRequests.delete(url);
  }

  private handleResponse(url: string, response: HttpEvent<unknown>): void {
    if ((response as HttpResponse<unknown>).ok) {
      this.remove(url);
    }

    this._isReady$.next(!this.openRequests.size);
  }
}
